import { IAnimationStateListener } from "pixi-spine";
import { State } from "../../../vendor_core/core/src/states/State";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import BURFeatureModel from "../models/BURFeatureModel";
import BURReelSymbol from "../view/BURReelSymbol";
import BURReelsModel from "../models/BURReelsModel";
import gsap from "gsap";
import { playSceneShake, stopSceneShake } from "../view/SceneShake";
import { GameLayers } from "../enums/GameLayers";

export default class BURPlayRandomWildsState extends State {
    public async enter() {
        super.enter();
        const wildsPositions = BURFeatureModel.random_wilds_positions;

        const buffaloRush = ViewManager.getLayer(GameLayers.Buffalos)
            .getCurrentScene()
            .spineAnimations.get("buffalo")!;

        const listener: IAnimationStateListener = {
            event(_, event) {
                if (event.data.name === "add_symbols") {
                    wildsPositions.map((pos) => {
                        const reel = BURReelsModel.reels.reels[pos.x];
                        const symbol = reel.symbols[pos.y] as BURReelSymbol;
                        symbol.setIsMystery(false);
                        symbol.setId(1);
                        symbol.y = reel.symbolsPositions[pos.y].y;
                        symbol.setIsLocked(true);
                    });
                }
            }
        };

        buffaloRush.state.addListener(listener);

        // Scene shake
        playSceneShake(BURReelsModel.shake_layers);

        gsap.delayedCall(1, async () => {
            // Start buffalo rush
            buffaloRush.visible = true;
            await buffaloRush.playAsync();

            // Clearup
            stopSceneShake();
            buffaloRush.state.removeListener(listener);
            buffaloRush.visible = false;

            this.exit();
        });
    }
}
